module.exports = __webpack_public_path__ + "static/media/1.09df8311.svg";